import { render, staticRenderFns } from "./GroupSettingPageData.vue?vue&type=template&id=8aec3bfa"
import script from "./GroupSettingPageData.vue?vue&type=script&lang=js"
export * from "./GroupSettingPageData.vue?vue&type=script&lang=js"
import style0 from "./GroupSettingPageData.vue?vue&type=style&index=0&id=8aec3bfa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports